import { TableColumnDefinition } from '../table/table-column-definition'

export const ServicePlanReconciliationTableColumnDefinitions: TableColumnDefinition[] =
  [
    {
      columnName: 'clientName',
      header: 'SERVICE_PLAN_RECONCILIATION.COLUMN_CLIENT_NAME',
      sortDisabled: true,
      columnType: 'link',
      columnWidth: '180px',
      columnTextAlign: 'left',
      linkColor: 'primary',
      linkKind: 'standard',
      showIcon: false,
    },
    {
      columnName: 'dateOfBirth',
      header: 'SERVICE_PLAN_RECONCILIATION.COLUMN_DATE_OF_BIRTH',
      sortDisabled: true,
      columnType: 'string',
      columnWidth: '110px',
      columnTextAlign: 'left',
    },
    {
      columnName: 'submittedOn',
      header: 'SERVICE_PLAN_RECONCILIATION.COLUMN_SUBMITTED_ON',
      sortDisabled: true,
      columnType: 'string',
      columnWidth: '140px',
      columnTextAlign: 'left',
    },
    {
      columnName: 'pdfGeneratedOn',
      header: 'SERVICE_PLAN_RECONCILIATION.COLUMN_PDF_GENERATED',
      sortDisabled: true,
      columnType: 'string',
      columnWidth: '130px',
      columnTextAlign: 'left',
    },
    {
      columnName: 'emailSentOn',
      header: 'SERVICE_PLAN_RECONCILIATION.COLUMN_EMAIL_SENT',
      sortDisabled: true,
      columnType: 'string',
      columnWidth: '130px',
      columnTextAlign: 'left',
    },
    {
      columnName: 'pdfAttachedOn',
      header: 'SERVICE_PLAN_RECONCILIATION.COLUMN_PDF_ATTACHED',
      sortDisabled: true,
      columnType: 'string',
      columnWidth: '130px',
      columnTextAlign: 'left',
    },
    {
      columnName: 'noteCreatedOn',
      header: 'SERVICE_PLAN_RECONCILIATION.COLUMN_NOTE_CREATED',
      sortDisabled: true,
      columnType: 'string',
      columnWidth: '130px',
      columnTextAlign: 'left',
    },
    {
      columnName: 'failureReason',
      header: 'SERVICE_PLAN_RECONCILIATION.COLUMN_FAILURE_REASON',
      sortDisabled: true,
      columnType: 'truncated-string',
      columnWidth: '200px',
      columnTextAlign: 'left',
    },
    {
      columnName: 'retry',
      header: 'SERVICE_PLAN_RECONCILIATION.COLUMN_ACTIONS',
      sortDisabled: true,
      columnType: 'link-button',
      columnWidth: '100px',
      columnTextAlign: 'left',
      linkButtonColor: 'primary',
      linkButtonType: 'button',
    },
  ]
